import { useAuth0 } from '@auth0/auth0-react'
import { Step } from '@mui/material'
import { ResiliaIconWhite } from 'Components/Views/AppBar/AppLogoBlue'
import { IntakeFlowStep, STEPPER_GROUPS } from '../../constants'
import {
  Header,
  StepperContent,
  StyledStepLabel,
  StyledStepper,
  SignOut,
} from './StepperHeader.styled'

interface StepperHeaderProps {
  currentStep: IntakeFlowStep
}

export const StepperHeader = ({ currentStep }: StepperHeaderProps) => {
  const { logout } = useAuth0()

  const getCurrentGroupIndex = () => {
    const groupIndex = STEPPER_GROUPS.findIndex((group) =>
      group.steps.includes(currentStep)
    )
    return Math.max(0, groupIndex)
  }

  return (
    <Header>
      <ResiliaIconWhite />
      <StepperContent>
        <StyledStepper activeStep={getCurrentGroupIndex()}>
          {STEPPER_GROUPS.map((group) => (
            <Step key={group.title}>
              <StyledStepLabel>{group.title}</StyledStepLabel>
            </Step>
          ))}
        </StyledStepper>
      </StepperContent>
      <SignOut variant='form' label='Sign Out' onClick={() => logout()} />
    </Header>
  )
}
